import Vue from "vue";
import {AXIOS} from "@/lib/http-common";
import Property from "@/components/properties/model/Property";
import UserActionResultSender from "@/components/application/UserActionResultSender";

export default class PropertiesService extends Vue {
  public static getInstance(): PropertiesService {
    if (!this.instance) {
      this.instance = new PropertiesService();
    }
    return this.instance;
  }

  private static instance: PropertiesService;

  public getProperties(): Promise<Property[]> {
    return AXIOS.get("/properties")
      .then((message) => {
        return message.data;
      });
  }

  public getPropertyByKey(key: string): Promise<Property> {
    return AXIOS.get(`/properties/${key}`)
      .then((message) => {
        return message.data;
      });
  }

  public fetchAndSetProperty<T>(
    key: string,
    handler: (value: T) => void
  ): Promise<void> {
    return this.getPropertyByKey(key)
      .then((property) => {
        const value = this.parseValue<T>(property.propValue);
        handler(value);
      })
      .catch((error) => {
        UserActionResultSender.showErrorFeedback(error.response.data.responseCode);
      });
  }

  private parseValue<T>(value: unknown): T {
    if (typeof value === 'string') {
      const lower = value.toLowerCase();
      if (lower === 'true') {
        return true as unknown as T;
      }
      if (lower === 'false') {
        return false as unknown as T;
      }
    }
    return value as T;
  }

}
